<div>
  <div class="modal-header">
      <h4 class="modal-title">
          Add containers
      </h4>
  </div>
  <form [formGroup]="addContainerLineItem">
      <div class="modal-body">
          <div class="row">
              <div class="col-md-12 m-b-sm">
                  <label>Type</label>
                  <ng-select formControlName="createSource" [items]="availableCtrSources" bindLabel="name"
                      placeholder="Choose a data source">
                  </ng-select>
              </div>
          </div>

          <!-- id of 1 is the id of BULK INSERT -->
          <div *ngIf="this.addContainerLineItem.value.createSource.id === 1">
              <div class="row">
                  <div class="col-md-12 m-b-sm">
                      <label>Door Direction</label>
                      <ng-select formControlName="doorDirection" [items]="doorDirections" bindLabel="name"
                          placeholder="Select the door direction">
                      </ng-select>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-12 m-b-sm">
                      <label>Container count</label>
                      <input type="number" formControlName="ctrCount" class="form-control text-capitalize" />
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-12 m-b-sm">
                      <label>Container Numbers</label>
                      <p>Paste container numbers below, they can be seperated by a comma, a space, a new line OR can be left blank.</p>
                  </div>
                  <div class="col-md-6">
                      <textarea
                          id="ContainerText"
                          (paste)="onPaste($event)"
                          (input)="onInput($event)"
                          class="form-control text-capitalize"
                          placeholder="Paste Container Numbers"
                          rows="15"></textarea>
                  </div>
                  <div class="col-md-6 table-responsive" style="height:320px;">
                      <table *ngIf="containerNumberList" class="table">
                          <tbody>
                              <tr *ngFor="let containerNumber of containerNumberList">
                                  <td [ngStyle]="{ 'color': isValidContainerNumber(containerNumber) ? '' : 'red' }">{{
                                      containerNumber }} </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>

          <!-- id of 1 is the id of BACC FILE -->
          <div *ngIf="this.addContainerLineItem.value.createSource.id === 3">
              <div class="row">
                  <div class="col-md-12">
                      <h4>Not currently available.</h4>
                  </div>
              </div>
          </div>
      </div>

      <div class="modal-footer">
          <button type="button" class="btn btn-mogo btn-primary" (click)="onSave()"
              [disabled]="addContainerLineItem.invalid">Add containers</button>
          <button type="button" class="btn btn-default" (click)="close()">Close</button>
      </div>
  </form>
</div>
